import { createSelector } from 'selectors'

import { constants } from './datetime.constant'

export const getTargets = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLSelectElement>>({ scope, selector: constants.selector.target }, true)
